// G1-A: menu grouped per role. Pure data + helpers (no "@/" imports) so Jest
// can test it. Hiding a menu item is NOT security: every endpoint and route
// still checks the role server-side / in ProtectedRoute.
import { OPERATOR_ROLES, PENGAWAS, ROLES } from "./roles";

const KASIR = ["admin", "kasir"];
const KANTOR = ["admin", "kasir", "desain"];
const M = "manager";  // owner 2026-10-11/12: production supervisor without money

// Group order fixed by the owner (G-1.md bagian 7 no. 3).
export const MENU_GROUPS = [
  {
    id: "transaksi",
    label: "Transaksi",
    items: [
      { to: "/transaksi-dp", label: "Transaksi DP", icon: "cart", roles: KASIR, testId: "nav-transaksi-dp" },
      { to: "/transaksi-dtf", label: "DTF", icon: "shirt", roles: KASIR, testId: "nav-dtf" },
      { to: "/transaksi-custom", label: "Custom", icon: "wrench", roles: KASIR, testId: "nav-custom" },
      { to: "/jersey", label: "Jersey", icon: "shirt", roles: KASIR, testId: "nav-jersey" },
      { to: "/price-list", label: "Price List", icon: "tag", roles: [...KASIR, "finance"], testId: "nav-price-list" },  // owner 2026-10-17: + Finance // owner 2026-10-10/11: Enduser, Reseller and Member prices, read-only
      { to: "/acc-mockup", label: "ACC & Mockup", icon: "image", roles: [...KANTOR, M], testId: "nav-acc" },  // v2.18: Manager reads only
      { to: "/customers", label: "Customer", icon: "contact", roles: KANTOR, testId: "nav-customer" },
      { to: "/status-order", label: "Status Order", icon: "activity", roles: [...KANTOR, M], testId: "nav-status" },
      { to: "/nota", label: "Nota", icon: "receipt", roles: KASIR, testId: "nav-nota" },
      { to: "/orders", label: "Order (lama)", icon: "clipboard", roles: KASIR, testId: "nav-order" },
    ],
  },
  {
    id: "pembayaran",
    label: "Pembayaran & Siap Diambil",
    items: [
      { to: "/pembayaran", label: "Pembayaran", icon: "wallet", roles: KASIR, testId: "nav-pembayaran" },
      { to: "/siap-diambil", label: "Siap Diambil", icon: "packageCheck", roles: KASIR, testId: "nav-siap-diambil" },
    ],
  },
  {
    id: "produksi",
    label: "Produksi",
    items: [
      { to: "/production", label: "Antrean", icon: "listChecks", roles: [...PENGAWAS, ...OPERATOR_ROLES], testId: "nav-antrean" },
      { to: "/jersey/desain", label: "Jersey Siap Desain", icon: "shirt", roles: ["desain"], testId: "nav-jersey-desain" },
      { to: "/riwayat-produksi", label: "Riwayat Produksi", icon: "history", roles: [...KANTOR, M], testId: "nav-riwayat-produksi" },
      // owner 2026-10-15 (A6): every station may LOOK at every SPK (no money; working stays in Antrean)
      { to: "/spk", label: "SPK", icon: "fileText", roles: ROLES, testId: "nav-spk" },
      { to: "/production-monitoring", label: "Monitoring", icon: "monitor", roles: PENGAWAS, testId: "nav-monitoring" },
      // owner 2026-10-19 (v2.11): thermal labels at the QC computer
      { to: "/label", label: "Antrean Label", icon: "tag", roles: ["admin", "qc"], testId: "nav-label" },
      { to: "/borongan", label: "Borongan Saya", icon: "coins", roles: OPERATOR_ROLES, testId: "nav-borongan-saya" },
      { to: "/spk-batal", label: "Pengajuan Batal SPK", icon: "fileText", roles: PENGAWAS, testId: "nav-spk-batal" },
      { to: "/tv", label: "TV", icon: "tv", roles: PENGAWAS, testId: "nav-tv", external: true },
    ],
  },
  {
    id: "stok",
    label: "Stok & Pembelian",
    items: [
      { to: "/stok", label: "Stok", icon: "boxes", roles: ["admin", "kasir", "finance", M], testId: "nav-stok" },
      { to: "/pembelian", label: "Pembelian", icon: "packagePlus", roles: ["admin", "finance"], testId: "nav-pembelian" },
    ],
  },
  {
    id: "keuangan",
    label: "Keuangan",
    items: [
      { to: "/kas", label: "Buku Kas", icon: "book", roles: ["admin", "finance"], testId: "nav-kas" },
      // owner 2026-10-15 (A9, masukan Finance): every payment per invoice, view only
      { to: "/riwayat-pembayaran", label: "Riwayat Pembayaran", icon: "history", roles: ["admin", "finance", "kasir"], testId: "nav-riwayat-bayar" },  // v2.13: Kasir/CS today only
      { to: "/borongan", label: "Borongan", icon: "coins", roles: ["admin", "finance"], testId: "nav-borongan" },
    ],
  },
  {
    id: "laporan",
    label: "Laporan",
    items: [
      // owner 2026-10-11/12: "Ringkasan Owner" became the dashboard (/ringkasan redirects to /)
      { to: "/laporan", label: "Laporan", icon: "chart", roles: ["admin", "kasir", "finance"], testId: "nav-laporan" },
      // owner 2026-10-16 (requirement 60): customer ratings from the digital nota, no money
      { to: "/masukan-customer", label: "Masukan Customer", icon: "star", roles: ["admin", M], testId: "nav-masukan" },
    ],
  },
  {
    id: "master",
    label: "Master Data",
    items: [
      { to: "/barang", label: "Barang", icon: "package", roles: PENGAWAS, testId: "nav-barang" },
      { to: "/bahan", label: "Bahan", icon: "layers", roles: ["admin", "finance", M], testId: "nav-bahan" }, // A3
      { to: "/supplier", label: "Supplier", icon: "truck", roles: ["admin", "finance"], testId: "nav-supplier" }, // A3
      { to: "/users", label: "Users", icon: "users", roles: PENGAWAS, testId: "nav-users" },
      { to: "/pos-produksi", label: "Pos Produksi", icon: "factory", roles: PENGAWAS, testId: "nav-pos" },
      { to: "/workflow", label: "Workflow", icon: "workflow", roles: PENGAWAS, testId: "nav-workflow" },
      { to: "/form-pos", label: "Form POS", icon: "clipboardCheck", roles: PENGAWAS, testId: "nav-form-pos" },
    ],
  },
  {
    id: "pengaturan",
    label: "Pengaturan",
    items: [
      { to: "/pengaturan", label: "Pengaturan", icon: "settings", roles: ["admin"], testId: "nav-pengaturan" },
      { to: "/whatsapp", label: "WhatsApp", icon: "message", roles: ["admin"], testId: "nav-whatsapp" },
      { to: "/hari-libur", label: "Hari Libur", icon: "calendar", roles: ["admin", "finance"], testId: "nav-hari-libur" },
      // owner 2026-10-19 (v2.10): Finance keeps the voice of the production screen; Owner/Manager reach it from Monitoring
      { to: "/production-monitoring/layar", label: "Suara Layar Produksi", icon: "tv", roles: ["finance"], testId: "nav-suara-layar" },
    ],
  },
];

// v2.15 (owner 2026-10-22, requirement 75 butir 4): the production screen for an account whose switch
// "Boleh lihat layar produksi" is on (role default Owner & Manager; the server decides on every request).
export const LAYAR_ITEM = { to: "/monitoring/layar", label: "Layar produksi", icon: "tv", roles: [], testId: "nav-layar-produksi", external: true };

export function menuForUser(user) {
  const groups = menuForRole(user?.role);
  if (!user?.layar_produksi_efektif) return groups;
  const prod = groups.find((g) => g.id === "produksi");
  if (prod) return groups.map((g) => (g.id === "produksi" ? { ...g, items: [...g.items, LAYAR_ITEM] } : g));
  const src = MENU_GROUPS.find((g) => g.id === "produksi");
  const out = [...groups];
  out.splice(Math.min(2, out.length), 0, { ...src, items: [LAYAR_ITEM] });
  return out;
}

export const DASHBOARD_ITEM = { to: "/", label: "Dashboard", icon: "dashboard", testId: "nav-dashboard" };

// Groups (in fixed order) with only the items this role may open; empty
// groups are dropped.
export function menuForRole(role) {
  if (!role) return [];
  return MENU_GROUPS.map((g) => ({ ...g, items: g.items.filter((it) => it.roles.includes(role)) }))
    .filter((g) => g.items.length > 0);
}

// Production operators (incl. CS/Desain, whose work is the DESAIN queue) land
// on their queue; office roles land on the dashboard.
export function homeForRole(role) {
  if (role === "manager") return "/production-monitoring";  // owner 2026-10-12
  return OPERATOR_ROLES.includes(role) ? "/production" : "/";
}

// Group holding the current path (longest matching prefix), so it stays open.
export function activeGroupId(groups, pathname) {
  let best = null;
  let bestLen = -1;
  for (const g of groups) {
    for (const it of g.items) {
      const hit = pathname === it.to || (it.to !== "/" && pathname.startsWith(`${it.to}/`));
      if (hit && it.to.length > bestLen) {
        best = g.id;
        bestLen = it.to.length;
      }
    }
  }
  return best;
}
